const LabelInput = ({ value, onChange, label, name }) => {
  return (
    <>
      <label className="block text-sm font-medium text-gray-700">{label}</label>
      <input
        name={name}
        value={value}
        onChange={onChange}
        type="text"
        className="mt-1 py-3 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:border-0 focus:ring-[2px] focus:ring-[#1e40af] focus:ring-opacity-100"
      />
    </>
  );
};

export default LabelInput;
